import {computed, observable} from "mobx";
import {VarHelper} from "common-import/helpers";
import api from "./Product.API";

class ProductStore {
  @observable listApproved = [];

  @observable listNotApproved = [];

  @observable currentProduct = {};

  @computed get allListProject() {
    return [...this.listApproved, ...this.listNotApproved];
  }

  getAll = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };

  getListApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "approved": 1,
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };

  getListNotApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "approved": 0,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  getListNotApprovedUpdate = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "approved": 3,
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  search = async (name, approved) => {
    let res = await api.adminList({
      "name": name,
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "approved": approved ? 1 : 0,
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    if (approved) {
      this.listApproved = json.data;
    } else {
      this.listNotApproved = json.data;
    }
    return { status: true };
  };

  detail = async id => {
    const res = await api.detail(id);
    return await res.json();
  };

  update = async data => {
    console.log(data);
    const res = await api.update(data);
    if (res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async data => {
    let res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError }
    }
    return await res.json();
  };

  approve = async ({ id, approved }) => {
    const res = await api.approve({ id, approved: approved ? 1 : 0});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  delete = async (data) => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };
}

const productStore = new ProductStore();

export default productStore;



// WEBPACK FOOTER //
// ./src/services/product/Product.Store.js